import { RenderType, TypeRenderer } from '@graphcommerce/next-ui'
import dynamic from 'next/dynamic'
import { RowBlogContent } from '../Blog'
import HomePageNewsletterSection from '../BuilderIO/HomePageNewsletterSection'
import NewsletterSection from '../BuilderIO/NewsletterSection'
import { BestSellers } from '../Home/BestSellers'
import { HeroBannerIcons } from '../Home/HeroBannerIcons'
import { HomePageFaqs } from '../Home/HomePageFaqs'
import { NewItems } from '../Home/NewItems'
import { ReferralProgram } from '../Home/ReferralProgram'
import { WhyUseTempli } from '../Home/WhyUseTempli'
import { OrderProcessAndFAQ } from '../Product/OrderProcessAndFAQ'
import { PageContentQueryFragment } from './PageContentQueryFragment.gql'
import { RowBrandsBanner } from './RowBrandsBanner/RowBrandsBanner'
import { RowFeaturedCategory } from './RowFeaturedCategory/RowFeaturedCategory'
import { RowHeroBanner } from './RowHeroBanner/RowHeroBanner'
import { RowParagraph } from './RowParagraph/RowParagraph'
import { RowProduct } from './RowProduct/RowProduct'
import { RowProductHighlight } from './RowProductHighlight/RowProductHighlight'
import { RowRendererFragment } from './RowRenderer.gql'
import { RowReviewHighlight } from './RowReviewHighlights/RowReviewHighlight'
import { RowServiceOptions } from './RowServiceOptions/RowServiceOptions'
import { RowServicePageContent } from './RowServicePageConent/RowServicePageContent'
import { RowSocialsHighlight } from './RowSocialsHighlight/RowSocialsHighlight'

type ContentTypeRenderer = TypeRenderer<PageContentQueryFragment['pages'][0]['content'][0]>

const defaultRenderer: Partial<ContentTypeRenderer> = {
  RowHeroBanner,
  RowBlogContent,
  RowServiceOptions,
  RowProduct,
  RowProductHighlight,
  RowBrandsBanner,
  RowServicePageContent,
  RowReviewHighlight,
  RowFeaturedCategory,
  RowParagraph,
  RowSocialsHighlight,
}

export type PageProps = RowRendererFragment & {
  renderer?: Partial<ContentTypeRenderer>
}

export function RowRenderer(props: PageProps) {
  const { content, renderer } = props
  const mergedRenderer = { ...defaultRenderer, ...renderer } as ContentTypeRenderer
  const withNoSSR = (Component: React.FunctionComponent) =>
    dynamic(() => Promise.resolve(Component), { ssr: false })

  const BestSellersWithNoSSR = withNoSSR(BestSellers)

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <div className='bg-pure-white'>
      {content?.map((item, idx) => (
        <>
          {/* {idx === 3 && content?.length > 1 && <WhyUseTempli />} */}
          {idx === 5 && content?.length > 1 && <BestSellersWithNoSSR />}
          {idx === 5 && content?.length > 1 && <OrderProcessAndFAQ />}
          {idx === 5 && content?.length > 1 && <HeroBannerIcons />}
          <RenderType key={item.id} renderer={mergedRenderer} {...item} />
          {/* {idx === content.length - 1 && content?.length > 1 && <HomePageFaqs />} */}
          {idx === content.length - 1 && content?.length > 1 && <HomePageNewsletterSection />}
        </>
      ))}
    </div>
  )
}
